import script from "./ScrollTopButtonComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollTopButtonComponent.vue?vue&type=script&setup=true&lang=js"

import "./ScrollTopButtonComponent.vue?vue&type=style&index=0&id=65940011&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65940011"]])

export default __exports__